import { Params as GetPolicyParams } from '../hooks/queries/usePolicyQuery';
import { POLICY_ID_MAP } from '../types/hubEnums';
import { getWebsiteDomainByCountry } from '../util/helper/website';
import { sendGetRequest } from './RequestService';

class PolicyService {
  static async getPolicy({ country, policyType }: GetPolicyParams) {
    const domain = getWebsiteDomainByCountry(country);
    const url = `${domain}/wp-json/wp/v2/pages/${POLICY_ID_MAP[policyType]}`;
    try {
      const res = await sendGetRequest({
        payload: {},
        url,
      });
      return res.json();
    } catch (error) {
      throw error;
    }
  }
}

export default PolicyService;
